import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, of, switchMap } from 'rxjs';
import { BadResponseWithError } from '../../../shared/models/bad-response-with-error.interface';
import {
    TournamentMatchesTabItem,
} from '../../models/api/requests/tournamentMatches.request';
import { TournamentMatchesService } from '../../services/tournament-matches.service';
import { TournamentMatchesActions } from '../actions/actions-type.action';

@Injectable()
export class TournamentMatchesEffect {
    private actions$ = inject(Actions);
    private tournamentMatchesService = inject(TournamentMatchesService);

    fetchTournamentMatches$ = createEffect(() =>
        this.actions$.pipe(
            ofType(TournamentMatchesActions.fetchTournamentMatches),
            switchMap((action) =>
                this.tournamentMatchesService
                    .fetchTournamentMatches(action.payload.tournamentId, action.payload.page, action.payload.pageSize)
                    .pipe(
                        map((response: any) =>
                            TournamentMatchesActions.fetchTournamentMatchesSuccess(
                                {
                                    payload: response,
                                }
                            )
                        ),
                        catchError((response: BadResponseWithError) =>
                            of(
                                TournamentMatchesActions.fetchTournamentMatchesFailure(
                                    {
                                        payload: response,
                                    }
                                )
                            )
                        )
                    )
            )
        )
    );
    fetchTournamentV2Matches$ = createEffect(() =>
        this.actions$.pipe(
            ofType(TournamentMatchesActions.fetchTournamentV2Matches),
            switchMap((action) =>
                this.tournamentMatchesService
                    .fetchTournamentV2Matches(action.payload.tournamentId, action.payload.page, action.payload.pageSize)
                    .pipe(
                        map((response: any) =>
                            TournamentMatchesActions.fetchTournamentV2MatchesSuccess(
                                {
                                    payload: response,
                                }
                            )
                        ),
                        catchError((response: BadResponseWithError) =>
                            of(
                                TournamentMatchesActions.fetchTournamentV2MatchesFailure(
                                    {
                                        payload: response,
                                    }
                                )
                            )
                        )
                    )
            )
        )
    );

    fetchTournamentPlayerMatches$ = createEffect(() =>
        this.actions$.pipe(
            ofType(TournamentMatchesActions.fetchTournamentPlayerMatches),
            switchMap((action) =>
                this.tournamentMatchesService
                    .fetchTournamentPlayerMatches(action.payload.tournamentId, action.payload.playerId)
                    .pipe(
                        map((response: TournamentMatchesTabItem[]) =>
                            TournamentMatchesActions.fetchTournamentPLayerMatchesSuccess(
                                {
                                    payload: response,
                                }
                            )
                        ),
                        catchError((response: BadResponseWithError) =>
                            of(
                                TournamentMatchesActions.fetchTournamentPLayerMatchesFailure(
                                    {
                                        payload: response,
                                    }
                                )
                            )
                        )
                    )
            )
        )
    );

    fetchTournamentPlayerV2Matches$ = createEffect(() =>
        this.actions$.pipe(
            ofType(TournamentMatchesActions.fetchTournamentPlayerV2Matches),
            switchMap((action) =>
                this.tournamentMatchesService
                    .fetchTournamentPlayerV2Matches(action.payload.tournamentId, action.payload.playerId)
                    .pipe(
                        map((response: TournamentMatchesTabItem[]) =>
                            TournamentMatchesActions.fetchTournamentPlayerV2MatchesSuccess(
                                {
                                    payload: response,
                                }
                            )
                        ),
                        catchError((response: BadResponseWithError) =>
                            of(
                                TournamentMatchesActions.fetchTournamentPlayerV2MatchesFailure(
                                    {
                                        payload: response,
                                    }
                                )
                            )
                        )
                    )
            )
        )
    );
}
